/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagementCreateMemberResponse } from './MemberManagementCreateMemberResponse';

export type MemberManagementCreateMemberResponseApiRespoonse = {
    data?: MemberManagementCreateMemberResponse;
    status?: MemberManagementCreateMemberResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MemberManagementCreateMemberResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

